import React, { useState, useEffect, useMemo } from 'react';
import { useNavigate, useParams, Link } from 'react-router-dom';

import { Modal } from 'react-bootstrap';
import { Button } from 'react-bootstrap';
import { Form } from 'react-bootstrap';
import { InputGroup } from 'react-bootstrap';
import { Badge } from 'react-bootstrap';

import { ListGroup } from 'react-bootstrap';
import { Container } from 'react-bootstrap';
import { Row } from 'react-bootstrap';
import { Col } from 'react-bootstrap';
import { OrdersFetchAPI } from '../../api/Orders';
import moment from 'moment-timezone';

import ModalCreateNewClient from './ModalCreateNewClient';

function Modalclient({ getClientsByBusiness, setRuc, setName, setDv, setDataResponse, callCenter, setdataClientSelected, dataClientSelected }) {
    const [showModal, setShowModal] = useState(false)
    const [clients, setClients] = useState([])
    const [searchedClients, setSearchedClients] = useState("")
    const [searchTerm, setSearchTerm] = useState('');
    const [deleteMode, setDeleteMode] = useState(false)
    const [orderSort, setOrderSort] = useState('asc')
    let token = localStorage.getItem("x-access-token")

    let user = localStorage.getItem('user');


    const getClients = async () => {
        let clients_data = await getClientsByBusiness()
        //let dataFilter = clients_data.filter(({ is_validated }) => is_validated == 1)

        console.log(clients_data);
        let dataFilter = clients_data.filter(({ ruc, dv }) => ruc != "0" && dv != "0" && ruc != "" && dv != "" && ruc != null && dv != null && ruc != "00000-00" && dv != "00")
        sortJSON(dataFilter, "name")

        /*if (callCenter == true) {
            let clientSort = sortJSON(clients_data, "name")
            setClients(clientSort)
            setSearchedClients(clientSort)
        } else {
            setClients(dataFilter)
            setSearchedClients(dataFilter)
        }*/

        let clientSort = sortJSON(clients_data, "name")
        setClients(clientSort)
        setSearchedClients(clientSort)

    }


    function sortJSON(data, key) {
        return data.sort(function (a, b) {
            var x = a[key],
                y = b[key];

            if (orderSort === 'asc') {
                return ((x < y) ? -1 : ((x > y) ? 1 : 0));
            }

            if (orderSort === 'desc') {
                return ((x > y) ? -1 : ((x < y) ? 1 : 0));
            }
        });
    }


    const handleFilter = () => {
        if (orderSort === 'asc') {
            setOrderSort('desc')

        } else {
            setOrderSort('asc')
        }


        if (searchTerm === '') {
            sortJSON(clients, 'name')
        } else {
            sortJSON(filteredProducts, 'name')
        }
    }

    const handleSaveClient = (data) => {

        if (callCenter == true) {
            setdataClientSelected(data);
            console.log("client", data);
        } else {
            setRuc(data.ruc)
            setName(data.name)
            setDv(data.dv)
            setDataResponse(true)
        }

        getTransactionByClient(data.id);
        setOrderSort('asc')
        setShowModal(false)
        setSearchTerm('')
    }


    const [business_code, setbusiness_code] = useState(() => {
        if (localStorage.getItem("business") != "" && localStorage.getItem("business") != undefined) {
            return JSON.parse(localStorage.getItem("business")).code
        }
    });
    const [branchoffice_code, setbranchoffice_code] = useState(() => {
        if (localStorage.getItem("branchoffice") != "" && localStorage.getItem("branchoffice") != undefined) {
            return JSON.parse(localStorage.getItem("branchoffice")).code
        }
    });

    const [machine, setmachine] = useState(() => {
      if (localStorage.getItem("machine") != "" && localStorage.getItem("machine") != undefined) {
         return JSON.parse(localStorage.getItem("machine"))
      }
   });

    const [minDate, setMinDate] = useState(moment(new Date()).tz('America/Bogota').format('YYYY-MM-DD') + 'T00:00:00.000+00:00');
    const [maxDate, setMaxDate] = useState(moment(new Date()).tz('America/Bogota').format('YYYY-MM-DD') + 'T23:59:59.000+00:00');
    const getTransactionByClient = async (client_id) => {
        try {

            const response = await OrdersFetchAPI.getTransactionsByBranchOfficePaymentMethodbyTable(business_code, branchoffice_code, minDate, maxDate, 0, 0, machine.id, 0, token, client_id);
            console.log("historico de transacciones del cliente",response);
        } catch (error) {
            console.log(error);
        }
    }

    //Filter the products by the term searched 
    const filteredProducts = useMemo(() => {
        if (searchTerm === '') {
            return clients
        }
        return searchedClients.filter(data => {
            const nameMatch = data.name.toLowerCase().includes(searchTerm.toLocaleLowerCase());

            return nameMatch;
        })
    }, [searchTerm, clients]);


    useEffect(() => {
        if (callCenter == true && dataClientSelected == null) {
            getClients()
            setShowModal(true)
        }

    }, [dataClientSelected, callCenter]);




    return (
        <>
            <button className='w-100 py-2  btn btn-outline-primary rounded-3' type="button" onClick={() => (getClients(), setShowModal(true))}>
                <i class="uil uil-search"></i> Buscar cliente
            </button>

            <Modal
                className='bg-blur-sp'
                show={showModal}
                onHide={() => (setShowModal(false))}
                size='lg'
                centered>

                <Modal.Body className='p-2'>
                    <section className='flex-container'>
                        <div className="d-flex justify-content-center border-bottom-0">
                            <h2 className="modal-title fw-bold fs-5">
                                <i class="uil uil-users-alt"></i> Clientes
                            </h2>
                        </div>

                        <span className='p-0  text-primary fw-bold'>Seleccion de clientes </span>

                        <div className="d-flex justify-content-between m-2 ">
                            <form className="row g-3 align-content-center align-items-center">
                                <div className="col-auto ">
                                    <span className='mb-0 text-secondary fw-bold' ><i class="uil uil-search"></i> Buscar</span>
                                </div>
                                <div className="col-auto">
                                    <input
                                        spellcheck="false"
                                        className="form-control"
                                        type="text"
                                        step="any"
                                        placeholder="Ingrese el nombre del cliente"
                                        onChange={e => setSearchTerm(e.target.value)}

                                    />

                                </div>
                                <div className="col-auto">
                                    <Button variant="secondary" onClick={() => handleFilter()}> {orderSort === 'asc' ? <><i class="uil uil-sort-amount-down"></i> A-Z</> : <><i class="uil uil-sort-amount-up"></i> Z-A</>}</Button>
                                </div>

                            </form>

                            <div className='col-auto'><ModalCreateNewClient getClients={getClients}></ModalCreateNewClient></div>
                        </div>
                        {/* List  */}
                        <div className='container'>
                            <div className={"row item2  bg-light-subtle rounded-3 list-framer-stocks border-top border-bottom"}>

                                {filteredProducts.map(data => (
                                    <div className='col-12 col-lg-4  mt-2'>

                                        {/* <div
                                            className="card-products-menu w-100 h-100"
                                            onClick={() => handleSaveClient(data)}
                                        >
                                            <div className=" p-1">
                                                <div className='justify-content-cente d-block text-center'>
                                                    <i class="uil uil-user-circle text-center"> </i>
                                                </div>
                                                <span className='text-secondary fw-normal h6'>
                                                    Nombre
                                                </span>
                                                <div className=' fw-semibold small text-wrap'>
                                                    {data.name}

                                                </div>
                                                {callCenter == true ? <></> : <>
                                                    <div>
                                                        <span className='text-secondary fw-normal h6'>
                                                            RUC
                                                        </span>
                                                        <div className=' fw-semibold small text-wrap'>
                                                            {data.ruc}
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <span className='text-secondary fw-normal h6'>
                                                            Dv
                                                        </span>
                                                        <div className=' fw-semibold small text-wrap'>
                                                            {data.dv}
                                                        </div>
                                                    </div>
                                                </>}
                                            </div>
                                        </div> */}


                                        <div className="card shadow-sm border-0 h-100" onClick={() => handleSaveClient(data)} role='button'>
                                            <div className="card-body p-1">
                                                {/* Header con ícono */}
                                                <div className="text-center mb-4 position-absolute top-0 start-0 m-1 bg-light rounded-circle">
                                                    <div className="d-inline-flex align-items-center justify-content-center rounded-circle bg-primary bg-gradient shadow-sm"
                                                        style={{ width: '2rem', height: '2rem' }}>
                                                        <i className="uil uil-user-circle text-white fs-5"></i>
                                                    </div>
                                                </div>

                                                {/* Nombre */}
                                                <div className="text-center mb-4">
                                                    <span className="d-block text-muted small fw-medium text-uppercase mb-2 opacity-75">
                                                        Nombre
                                                    </span>
                                                    <div className="h5 fw-semibold text-dark mb-0 text-wrap">
                                                        {data.name}
                                                    </div>
                                                </div>

                                                {/* RUC y DV - Solo si callCenter no es true */}
                                                {callCenter == true ? <></> : (
                                                    <div className="pt-3 border-top">
                                                        <div className="row g-3">
                                                            {/* RUC */}
                                                            <div className="col-6">
                                                                <span className="d-block text-muted small fw-medium text-uppercase mb-2 opacity-75">
                                                                    RUC
                                                                </span>
                                                                <div className="fw-semibold small text-dark text-wrap">
                                                                    {data.ruc}
                                                                </div>
                                                            </div>

                                                            {/* DV */}
                                                            <div className="col-6">
                                                                <span className="d-block text-muted small fw-medium text-uppercase mb-2 opacity-75">
                                                                    Dv
                                                                </span>
                                                                <div className="fw-semibold small text-dark text-wrap">
                                                                    {data.dv}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <small className='text-body-tertiary text-center'>
                            <i className="uil uil-info-circle me-1"></i>
                            Por favor, seleccione un cliente para personalizar la factura.
                        </small>
                        {/* List end  */}
                    </section>
                    <div className='d-block mt-lg-1 mt-0'>
                        <div className='d-flex justify-content-end mt-2'>
                            <button className='btn bg-danger-subtle text-danger  border-0 fw-bold '
                                onClick={() => (setShowModal(false), setSearchTerm(''), setOrderSort('asc'))}
                            >
                                <i class="uil uil-times-circle"></i>  Cancelar
                            </button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal >

        </>
    )
}

export default Modalclient